import { NgModule } from '@angular/core';
import { LIB_CommonModule } from 'pbc.angular';
import { PostStandortCommandService } from '.';

@NgModule({
  imports: [
    LIB_CommonModule,
  ],
  providers: [PostStandortCommandService],
  exports: []
})
export class PostStandortCommandServiceModule { }
